// extracted by mini-css-extract-plugin
module.exports = {"switch":"_2002NQWPrhd0nzAJhj1ELh","slider":"_2RqVqaEK8HVmlmVZ2LO9jI","round":"_3Vud8IJpmFkikOM3RfhbAR"};